import Vue from 'vue';

const PasswordResetForm = require('./components/passwords/PasswordResetForm').default;
Vue.component('password-reset-form', PasswordResetForm);

const app = new Vue({
    el: '#app',
});

